const COLOR = { rosso: "#D92D20", giallo: "#D97706", verde: "#16A34A" };

function Box({ title, children, testid, className = "" }) {
  return (
    <div className={`rounded-lg border border-[#262626] p-4 ${className}`} data-testid={testid}>
      <p className="text-[0.65rem] uppercase tracking-[0.2em] mb-2" style={{ color: "#D97706" }}>{title}</p>
      {children}
    </div>
  );
}

function List({ items, color, mark }) {
  return (
    <ul className="space-y-1.5">
      {(items || []).map((t, i) => <li key={i} className="text-sm text-neutral-300 leading-snug flex gap-2"><span style={{ color }} className="shrink-0">{mark}</span><span>{t}</span></li>)}
    </ul>
  );
}

export function DiagnosiResult({ r }) {
  if (!r) return null;
  return (
    <div className="space-y-4" data-testid="strategy-diagnosis-result">
      <div className="rounded-xl p-5 border" style={{ background: "rgba(217,119,6,0.10)", borderColor: "rgba(217,119,6,0.35)" }} data-testid="strategy-diagnosis-tesi">
        <p className="text-[0.65rem] uppercase tracking-[0.2em] text-neutral-400 mb-2">La tesi che emerge dai tuoi dati</p>
        <p className="font-display font-bold text-white text-xl leading-snug">«{r.tesi_emergente}»</p>
        {r.tesi_confronto && <p className="text-xs text-neutral-400 mt-3 leading-relaxed"><span className="text-neutral-500">Confronto con la tesi dichiarata:</span> {r.tesi_confronto}</p>}
      </div>

      {r.sintesi && <p className="text-sm text-neutral-200 leading-relaxed border-l-2 pl-4" style={{ borderColor: "#D97706" }} data-testid="strategy-diagnosis-sintesi">{r.sintesi}</p>}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Box title="Pain broad che fa reagire" testid="strategy-diagnosis-pain"><p className="text-sm text-neutral-300 leading-snug">{r.pain_broad}</p></Box>
        <Box title="Hook" testid="strategy-diagnosis-hook"><p className="text-sm text-neutral-300 leading-snug">{r.hook}</p></Box>
        <Box title="Nemico" testid="strategy-diagnosis-nemico">
          <p className="text-[0.62rem] uppercase text-neutral-500 mb-1">Funziona</p><List items={r.nemico?.funziona} color="#16A34A" mark="✔" />
          <p className="text-[0.62rem] uppercase text-neutral-500 mt-3 mb-1">Non funziona</p><List items={r.nemico?.non_funziona} color="#D92D20" mark="✗" />
        </Box>
        <Box title="Format" testid="strategy-diagnosis-format">
          <p className="text-[0.62rem] uppercase text-neutral-500 mb-1">Vincenti</p><List items={r.format?.vincenti} color="#16A34A" mark="✔" />
          <p className="text-[0.62rem] uppercase text-neutral-500 mt-3 mb-1">Mancanti</p><List items={r.format?.mancanti} color="#D97706" mark="+" />
        </Box>
        <Box title="Emozione" testid="strategy-diagnosis-emozione"><p className="text-sm text-neutral-300 leading-snug">{r.emozione}</p></Box>
        <Box title="CTA" testid="strategy-diagnosis-cta"><p className="text-sm text-neutral-300 leading-snug">{r.cta}</p></Box>
      </div>

      {Array.isArray(r.filiera) && r.filiera.length > 0 && (
        <Box title="La filiera letta dai dati" testid="strategy-diagnosis-filiera">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2">
            {r.filiera.map((a) => (
              <div key={a.anello} className="rounded-md bg-[#0d0d0d] border border-[#1f1f1f] p-2.5">
                <p className="text-xs font-bold text-white flex items-center gap-2"><span className="w-2 h-2 rounded-full" style={{ background: COLOR[a.stato] || "#525252" }} />{String(a.anello).padStart(2, "0")} {a.nome}</p>
                <p className="text-[0.68rem] text-neutral-400 leading-snug mt-1">{a.perche}</p>
              </div>
            ))}
          </div>
        </Box>
      )}

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <Box title="5 cose da cambiare da domani" testid="strategy-diagnosis-cambiare" className="lg:col-span-2">
          <ol className="space-y-3">
            {(r.cambiare || []).map((c, i) => (
              <li key={i} className="flex gap-3">
                <span className="font-display font-extrabold text-lg leading-none w-6 shrink-0" style={{ color: "#D97706" }}>{i + 1}</span>
                <div><p className="text-sm font-semibold text-white leading-snug">{c.azione}</p><p className="text-xs text-neutral-400 leading-snug mt-0.5">{c.perche}</p>{c.dato && <p className="text-[0.68rem] text-neutral-500 mt-0.5 font-mono">{c.dato}</p>}</div>
              </li>
            ))}
          </ol>
        </Box>
        <Box title="Smettere di fare" testid="strategy-diagnosis-smettere"><List items={r.smettere} color="#D92D20" mark="✗" /></Box>
      </div>

      {Array.isArray(r.prossimi_reel) && r.prossimi_reel.length > 0 && (
        <Box title="3 reel coerenti con la tesi emergente" testid="strategy-diagnosis-prossimi">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            {r.prossimi_reel.map((p, i) => (
              <div key={i} className="rounded-md bg-[#0d0d0d] border border-[#1f1f1f] p-3 space-y-1.5">
                <p className="text-sm font-semibold text-white leading-snug">{p.titolo}</p>
                {p.hook && <p className="text-[0.7rem] font-mono uppercase text-neutral-300 leading-snug border-l-2 pl-2" style={{ borderColor: "#D97706" }}>{p.hook}</p>}
                <p className="text-xs text-neutral-500">{p.format}</p>
                {p.nemico_fatto && <p className="text-xs text-neutral-400 leading-snug"><span className="text-neutral-500">Nemico-fatto:</span> {p.nemico_fatto}</p>}
              </div>
            ))}
          </div>
        </Box>
      )}
    </div>
  );
}
